namespace TabAurous.Production {
    export interface JobWorkIssueForm {
        TransDate: Serenity.DateEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        PartyId: Serenity.LookupEditor;
        LedgerName: Serenity.StringEditor;
        DepartmentId: Serenity.LookupEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        RefVoucherId: Serenity.IntegerEditor;
        RefTransId: Serenity.StringEditor;
        ItemDetails: JobWorkIssueItemsEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class JobWorkIssueForm extends Serenity.PrefixedContext {
        static formKey = 'Production.JobWorkIssue';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!JobWorkIssueForm.init)  {
                JobWorkIssueForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.StringEditor;
                var w3 = s.LookupEditor;
                var w4 = JobWorkIssueItemsEditor;

                Q.initFormType(JobWorkIssueForm, [
                    'TransDate', w0,
                    'VoucherTypeId', w1,
                    'VoucherNo', w2,
                    'PartyId', w3,
                    'LedgerName', w2,
                    'DepartmentId', w3,
                    'UserId', w3,
                    'EmployeeId', w1,
                    'RefVoucherId', w1,
                    'RefTransId', w2,
                    'ItemDetails', w4,
                    'CompanyId', w1,
                    'FinancialYearId', w1
                ]);
            }
        }
    }
}
